import OurLocation from "../pages/location/OurLocation";
import DrivingLocation from "../components/DrivingLocation";

const DrivingLesson = ({ information, lesson, settings }) => {

  return (
    <>
      <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-md-3 mb-3">
        <ul className="review-rating">
          {information &&
            information.features && information.features.length &&
            information.features.map((infoData, index) => (
              <li key={index}>{infoData}</li>
            ))}
        </ul>
        {information && information.register_url && (
          <div className="text-center mt-lg-5 mt-4 mb-lg-5 mb-4">
            <a href={information.register_url} target="_blank" rel="noreferrer" className="btn yellow-btn green-btn me-sm-4 me-md-3">
              Register <i className="fa-solid fa-circle-chevron-right"></i>
            </a>
          </div>
        )}
        <div>
          {/* <button onClick={toggleOpen} id="collapseOne" className="btn-scroll">miami</button> */}
          <button
            className="btn small-btn mt-5 mx-3 scroll-btn justify-content-center"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseOne"
            aria-expanded="true"
            aria-controls="collapseOne"
            onClick={() => {
              const ref1 = document.getElementById("collapseOne");
              ref1.scrollIntoView({ behavior: "smooth" });
            }}
          >
            Miami Dade County
          </button>
          <button
            className="btn small-btn mt-5 mx-3 justify-content-center"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseTwo"
            aria-expanded="false"
            aria-controls="collapseTwo"
            onClick={() => {
              const ref2 = document.getElementById("collapseTwo");
              ref2.scrollIntoView({ behavior: "smooth" });
            }}
          >
            Broward County
          </button>
          <button
            className="btn small-btn mt-5 mx-3 justify-content-center"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapseThree"
            aria-expanded="false"
            aria-controls="collapseThree"
            onClick={() => {
              const ref3 = document.getElementById("collapseThree");
              ref3.scrollIntoView({ behavior: "smooth" });
            }}
          >
            Palm Beach County
          </button>
          <button
            className="btn small-btn mt-5 mx-3 justify-content-center"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#collapsefour"
            aria-expanded="false"
            aria-controls="collapsefour"
            onClick={() => {
              const ref4 = document.getElementById("collapsefour");
              ref4.scrollIntoView({ behavior: "smooth" });
            }}
          >
            Central Florida
          </button>
        </div>
        <div className="new-driver-section new-driver-blog mb-md-5 mt-4 mb-4">
          {information && (
            <div
              dangerouslySetInnerHTML={{ __html: information.heading }}
            ></div>
          )}
          <div className="new-drivers-course">
            {lesson &&
              lesson.map((lessonData, lIndex) => (
                <div
                  key={lIndex}
                  className="d-flex justify-content-between flex-column course-detail-blog driving-package-block"
                >
                  <div className="text-center">
                    {/* <!-- <img src="assets/images/alcoholic-drink.png" alt="" className="mb-md-3 mb-2"> --> */}
                    <h5 className="course-detail-heading text-capitalize mb-md-3 mb-2">
                      {lessonData.name}
                    </h5>
                    {lessonData.features &&
                      lessonData.features.map((featureData, index) => (
                        <div key={index} className="package-features">
                          <p>{featureData}</p>
                        </div>
                      ))}
                  </div>
                  <div className="detail-btn d-flex align-items-center justify-content-space-between flex-column">
                    <div className="price mb-md-4 mb-3">
                      ${lessonData.price}
                    </div>
                    {lessonData.register_url && (
                      <a
                        href={lessonData.register_url} target="_blank" rel="noreferrer"
                        className="btn small-btn d-flex align-items-center justify-content-center"
                      >
                        Register
                        <i className="fa-solid fa-circle-chevron-right"></i>
                      </a>
                    )}
                  </div>
                </div>
              ))}
          </div>
        </div>

        <OurLocation settings={settings} />
        <DrivingLocation />
      </div>
    </>
  );
};

export default DrivingLesson;
